import type { PiralPlugin } from 'piral-core'
import type { ComponentType } from 'react'
import screenfull from 'screenfull'
import { FullscreenButton } from './FullscreenButton'

export const CONTENT_DOM_ID = 'wrw-content'
export const CONTENT_DOM_ELEMENT = () => document.getElementById(CONTENT_DOM_ID) || document.body

export interface AppContentApi {
  contentDomId: string
  contentDomElement: () => HTMLElement
  screenfullElement: () => HTMLElement | undefined
  screenfullOrRoot: () => HTMLElement
  FullscreenButton: ComponentType<{ element?: () => HTMLElement }>
}

export function createAppContentApi(): PiralPlugin<AppContentApi> {
  return () => ({
    contentDomId: CONTENT_DOM_ID,
    contentDomElement: CONTENT_DOM_ELEMENT,
    screenfullElement: () => screenfull.element as HTMLElement | undefined,
    screenfullOrRoot: () => (screenfull.element as HTMLElement) || document.body,
    FullscreenButton: FullscreenButton
  })
}
